import { List, Typography } from 'antd';
import React, { memo } from 'react';
import { aiAgentCenterMessages } from 'messages';
import AIChatItem from './AIChatItem';
import { useAIAgentCenterContext } from 'contexts/ai-agent-center';
import {
  useGetChatMonitoringUsers,
  useOmniChatSessionSupervisorInprogressList,
  useProfile,
  useSystemConfigAIAgent
} from 'hooks';
import { InView } from 'react-intersection-observer';
import { find } from 'lodash';

type AIChatListProps = {};

const AIChatList: React.FC<AIChatListProps> = () => {
  const { profile } = useProfile();
  const { isLoading, data: configAI } = useSystemConfigAIAgent();

  const { chatSession, setChatSession, filterForm } = useAIAgentCenterContext();

  const { chatSource } = filterForm || {};

  const { chatSessionSupervisorOngoing, handleLoadMore, hasMore } = useOmniChatSessionSupervisorInprogressList({
    keyword: '',
    isHandleByAi: true,
    source: chatSource,
    endpoint: 'useOmniChatSessionSupervisorInprogressListHandleByAi'
  });
  const { data: chatMonitoringUsers } = useGetChatMonitoringUsers();

  return (
    <div className='h-full max-h-full w-full overflow-y-auto'>
      <div className='flex h-11 items-center px-5'>
        <Typography.Text className='text-xs font-semibold uppercase text-colorTextPlaceholder'>
          {aiAgentCenterMessages.countActive(configAI?.concurrencyChat ?? 0, configAI?.maxConcurrencyChat ?? 0)}
        </Typography.Text>
      </div>
      <List
        className='w-full pb-5'
        dataSource={chatSessionSupervisorOngoing}
        renderItem={(item) => {
          const monitoringUsers = find(chatMonitoringUsers, (u) => u.chatSessionId === item.chatSessionId);
          return (
            <AIChatItem
              item={item}
              selected={chatSession?.chatSessionId === item.chatSessionId}
              onSelect={() => {
                setChatSession(item);
              }}
              monitoringUsers={monitoringUsers?.users.filter((o) => o.userId !== profile?.userId) || []}
            />
          );
        }}
        rowKey={'chatSessionId'}
        footer={
          hasMore ? (
            <InView
              className='-mt-3'
              onChange={(open) => {
                console.log('InView changed:', open);
                if (open) {
                  handleLoadMore();
                }
              }}
            >
              <div className='flex h-18 gap-3 px-5 py-3'>
                <div>
                  <div className='skeleton-active h-12 w-12 rounded-full'></div>
                </div>
                <div className='mt-[3px] flex flex-1 flex-col gap-1'>
                  <div className='skeleton-active h-5 w-[180px] rounded-sm'></div>
                  <div className='skeleton-active h-[18px] w-[100px] rounded-sm'></div>
                </div>
                <div className='mt-[3px] h-full'>
                  <div className='skeleton-active h-[14px] w-[60px] rounded-sm'></div>
                </div>
              </div>
            </InView>
          ) : null
        }
      />
    </div>
  );
};

export default memo(AIChatList);
